export const uploadingFilesSelector = (state) =>
  state.uploadingFiles.map((f, index) => ({
    ...f,
    uploadingFilesIndex: index,
  }));
